import { render } from "./ProjectFileContentDocumentsCard.vue?vue&type=template&id=0478b21c&scoped=true"
import script from "./ProjectFileContentDocumentsCard.vue?vue&type=script&lang=js"
export * from "./ProjectFileContentDocumentsCard.vue?vue&type=script&lang=js"

import "./ProjectFileContentDocumentsCard.vue?vue&type=style&index=0&id=0478b21c&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0478b21c"]])

export default __exports__